import React, { ReactElement } from 'react';
import styles from './IconCategoryMap.module.scss';
import classNames from 'classnames';
import {
    BUSINESS_EVENTBRITE_CATEGORY,
    DATING_EVENTBRITE_SUB_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HALLOWEEN_EVENTBRITE_SUB_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    NIGHTLIFE_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
} from '@eventbrite/consumer-search.categories/constants';
import {
    Arts,
    BusinessProfession,
    FoodDrink,
    Health,
    Hobbies,
    Mic,
    Sports,
    Tickets,
    Dating,
    DiscoBall,
    Halloween,
    HolidayCalendar,
} from '@eventbrite/legacy-eds.iconography';

export const WEEKEND_EVENTBRITE_CATEGORY = 'this_weekend';

export const CATEGORY_BROWSE_KEYS = [
    MUSIC_EVENTBRITE_CATEGORY,
    NIGHTLIFE_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    DATING_EVENTBRITE_SUB_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    BUSINESS_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
];

export const EVENTBRITE_CATEGORY_CAROUSEL_ICON_MAP: {
    [key: string]: ReactElement;
} = {
    [BUSINESS_EVENTBRITE_CATEGORY]: (
        <BusinessProfession
            viewBox="0 0 32 33"
            className={classNames(styles.iconFill, styles.iconSize)}
        />
    ),
    [MUSIC_EVENTBRITE_CATEGORY]: (
        <Mic viewBox="0 0 40 41" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
    [PERFORMING_EVENTBRITE_CATEGORY]: (
        <Arts viewBox="0 0 40 41" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
    [SEASONAL_EVENTBRITE_CATEGORY]: (
        <HolidayCalendar
            viewBox="0 0 28 36"
            className={classNames(styles.iconFill, styles.holidayIcon)}
        />
    ),
    [HALLOWEEN_EVENTBRITE_SUB_CATEGORY]: (
        <Halloween viewBox="0 0 25 26" className={classNames(styles.iconSize)} />
    ),
    [FOOD_AND_DRINK_EVENTBRITE_CATEGORY]: (
        <FoodDrink viewBox="0 0 40 41" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
    [WEEKEND_EVENTBRITE_CATEGORY]: (
        <Tickets viewBox="0 0 32 32" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
    [HEALTH_EVENTBRITE_CATEGORY]: (
        <Health viewBox="0 0 32 32" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
    [HOBBIES_EVENTBRITE_CATEGORY]: (
        <Hobbies viewBox="0 0 32 32" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
    [SPORTS_EVENTBRITE_CATEGORY]: (
        <Sports viewBox="0 0 32 32" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
    [NIGHTLIFE_EVENTBRITE_CATEGORY]: (
        <DiscoBall viewBox="0 0 47 48" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
    [DATING_EVENTBRITE_SUB_CATEGORY]: (
        <Dating viewBox="0 -5 45 45" className={classNames(styles.iconFill, styles.iconSize)} />
    ),
};
